var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"order-address"},[(_vm.from)?_c('div',_vm._l((_vm.from),function(v){return _c('div',{key:v},[_vm._v(" "+_vm._s(v)+" ")])}),0):_vm._e(),(_vm.from && _vm.to)?_c('div',[_vm._v("⬇")]):_vm._e(),(_vm.to)?_c('div',_vm._l((_vm.to),function(v){return _c('div',{key:v},[_vm._v(" "+_vm._s(v)+" ")])}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }